import { CircularProgress } from "@mui/material";

const CircularLoading = ({ style }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <CircularProgress style={style} />
    </div>
  );
};

export default CircularLoading;
